@if (popoverVisible) {
  <div
    #popoverElement
    class="popover-container"
    [ngClass]="
      actualPosition ? 'popover-' + actualPosition : 'popover-' + position
    "
    (click)="popoverVisible = false"
    [ngStyle]="popoverStyle"
  >
    <span class="popover-arrow" [ngStyle]="arrowStyle"></span>
    <div class="popover-tooltip">
      {{ popoverText }}
    </div>
  </div>
}
<div
  #divElement
  class="container"
  [ngClass]="cellClass"
  (click)="showPopover()"
>
  <ng-content></ng-content>
</div>
